export {
  imageType,
  areaMap,
  genreMap,
  subGenreMap,
  hasSubGenreSet
} from '@/utils/constants'

export const actorTypeList = [
  {
    id: 0,
    name: '男',
    disabled: false
  },
  {
    id: 1,
    name: '女',
    disabled: false
  },
  {
    id: 2,
    name: '组合',
    disabled: false
  },
  {
    id: 3,
    name: '其他',
    disabled: false
  },
  {
    id: 5,
    name: '虚拟',
    disabled: false
  },
]
export const actorTypeMap = actorTypeList.reduce((result, item) => {
  result[item.id] = item.name

  return result
}, {})

export const roleMap = Object.freeze({
  0: '歌手',
  1: '音乐人',
  2: 'DJ',
  3: '声优',
  4: '曲艺家',
  5: '主播',
  6: 'UGC',
  7: '演奏家',
  8: '指挥家',
  9: '作词',
  10: '作曲',
  11: '编曲',
  12: '制作人',
  13: '演员',
  14: '主持人',
  15: '其他',
})
